import React, { FC } from 'react';

import Link from 'buyside/components/presentation/Link/link';

import { employerProfileUrl, profileUrl } from 'buyside/util/urlHelper';

import { MainNavigationCurrentUserQuery } from 'interfaces/graphql-typings';

import styles from './navigationUserStyles.scss';

const NavigationUserHeader: FC<{
  currentEmployers: NonNullable<MainNavigationCurrentUserQuery['currentUser']>['currentEmployers'];
  displayName: string;
  isAllocator: boolean;
  profileId: string;
  profileImageUrl: string;
}> = ({ currentEmployers, displayName, isAllocator, profileImageUrl, profileId }) => {
  return (
    <div className={styles.dropdownHeader}>
      <img className={styles.dropdownHeaderProfileImage} src={profileImageUrl} />
      <div className={styles.dropdownHeaderContent}>
        {isAllocator ? (
          <p>
            <strong>{displayName}</strong>
          </p>
        ) : (
          <Link to={profileUrl(profileId)}>{displayName}</Link>
        )}
        {currentEmployers.map((currentEmployer, idx) => (
          <Link key={`navigation-user-employer-${idx}`} to={employerProfileUrl(currentEmployer.id)}>
            {currentEmployer.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NavigationUserHeader;
